const initialState = {
  data: [],
  current_org: {
    org: [{
      name: ""
    }],
    subsPlanList: [],
    api_master: [],
    org_types: []
  },
  locations: [],
  total_locations_count: 0,
  distributors: [],
  total_distributors_count: 0,
  users: [],
  total_users_count: 0,
  products: [],
  total_products_count: 0,
  subcription_lists: [],
  org_setting_lists: [],
  org_setting_lists_value: [],
  tdForcastList: [],
  tdForcastListForImport: [],
  tdForcastListWeeks: [],
  buForcastListForImport: [],
  buForcastListWeeks: [],
  total_tdForcastList_count: 0,
  buForcastList: [],
  total_buForcastList_count: 0,
  roForcastList: [],
  total_roForcastList_count: 0,
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  sortIndex: [],
  logList: [],
  total_logList_count: 0,
}

const determinePopularity = val => {
  if (val >= 75) return { popValue: val, color: "success" }
  else if (val < 75 && val >= 55) return { popValue: val, color: "primary" }
  else if (val < 55 && val >= 35) return { popValue: val, color: "warning" }
  else if (val < 35 && val >= 0) return { popValue: val, color: "danger" }
  else return { popValue: 0, color: "danger" }
}

const moveIndex = (arr, from, to) => {
  let el = arr[from]
  arr.splice(from, 1)
  arr.splice(to, 0, el)
}

const getIndex = (arr, arr2, arr3, params = {}) => {
  if (arr2.length > 0) {
    let startIndex = arr.findIndex && arr.findIndex(i => i.id === arr2[0].id) + 1
    let endIndex = arr.findIndex && arr.findIndex(i => i.id === arr2[arr2.length - 1].id) + 1
    let finalArr = [startIndex, endIndex]
    return (arr3 = finalArr)
  } else {
    let finalArr = [arr.length - parseInt(params.perPage), arr.length]
    return (arr3 = finalArr)
  }
}

const OrganizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DATA":
      return {
        ...state,
        data: action.data.org,
        totalPages: action.totalPages,
        params: action.params,
        totalRecords: action.totalRecords,
        allData: action.data.org,
        sortIndex: action.sortIndex
      }
    case "SET_CURRENT_ORG":
      return {
        ...state,
        current_org: action.data,
      }
    case "SET_CURRENT_ORG_LOCATIONS":
      return {
        ...state,
        locations: action.data,
      }
    case "SET_TOTAL_ORG_LOCATIONS" :
      return {
        ...state,
        total_locations_count: Number(action.data)
      }
    case "SET_CURRENT_ORG_DISTRIBUTORS":
      return {
        ...state,
        distributors: action.data,
      }
    case "SET_TOTAL_ORG_PRODUCTS":
      return {
        ...state,
        total_products_count: action.data,
      }
    case "SET_CURRENT_ORG_PRODUCTS":
      return {
        ...state,
        products: action.data,
      }
    case "SET_TOTAL_ORG_DISTRIBUTORS" :
      return {
        ...state,
        total_distributors_count: Number(action.data)
      }
    case "SET_CURRENT_ORG_USERS":
      return {
        ...state,
        users: action.data,
      }
    case "SET_TOTAL_ORG_USERS" :
      return {
        ...state,
        total_users_count: Number(action.data)
      }
    case "SET_SUBSCRIPTION_LIST" :
      return {
        ...state,
        subcription_lists: action.data
      }
    case "SET_ORG_SETTINGS" :
      return {
        ...state,
        org_setting_lists: action.data.orgSettingList,
        org_setting_lists_value: action.data.settingList
      }
    case "SET_ORG_TD_FORCAST":
      return {
        ...state,
        tdForcastList: action.data.tdForecastList,
        total_tdForcastList_count: action.data.total_count,
      }
    case "SET_ORG_TD_FORCAST_LIST_IMPORT":
      return {
        ...state,
        tdForcastListForImport: action.data.tdForecastList,
      }
    case "SET_ORG_TD_FORCAST_WEEKS":
      return {
        ...state,
        tdForcastListWeeks: action.data.weekId,
      }
    case "SET_ORG_BU_FORCAST_LIST_IMPORT":
      return {
        ...state,
        buForcastListForImport: action.data.tdForecastList,
      }
    case "SET_ORG_BU_FORCAST_WEEKS":
      return {
        ...state,
        buForcastListWeeks: action.data.weekId,
      }
    case "SET_ORG_BU_FORCAST":
      return {
        ...state,
        buForcastList: action.data.buForecastList,
        total_buForcastList_count: action.data.total_count,
      }
    case "SET_ORG_RO_FORCAST":
      return {
        ...state,
        roForcastList: action.data.reorderList,
        total_roForcastList_count: action.data.total_count,
      }
    case "SET_ORG_LOGS":
      return {
        ...state,
        logList: action.data.logs,
        total_logList_count: action.data.total_count,
      }
    case "GET_ALL_DATA":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "GET_ALL_MASTER_DATA":
      return {
        ...state,
        allMasterData: action.data,
        totalMasterRecords: action.data.length,
      }
    case "CUSTOM_FILTER_DATA":
        let filteredData = []
      if (action.value.length) {
        filteredData = action.value

        console.log(' filterData: ', filteredData);
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    case "ADD_DATA":
      let id = state.data.slice(-1)[0].id + 1
      state.data.push({
        ...action.obj,
        id,
        popularity: determinePopularity(action.obj.popularity)
      })
      moveIndex(
        state.data,
        state.data.findIndex(item => item.id === id),
        0
      )
      return {
        ...state,
        data: state.data,
        totalRecords: state.allData.length,
        sortIndex: getIndex(state.allData, state.data, state.sortIndex)
      }
    case "UPDATE_DATA":
      state.data.find(item => {
        if (item.id === action.obj.id) {
          let popularity = determinePopularity(action.obj.popularity.popValue)
          return Object.assign(item, { ...action.obj, popularity })
        } else {
          return item
        }
      })
      return { ...state }
    case "DELETE_DATA":
      let index = state.data.findIndex(item => item.id === action.obj.id)
      let updatedData = [...state.data]
      updatedData.splice(index, 1)
      return {
        ...state,
        data: updatedData,
        totalRecords: state.allData.length,
        sortIndex: getIndex(
          state.allData,
          state.data,
          state.sortIndex,
          state.params
        )
      }
    default:
      return state
  }
}

export default OrganizationReducer
